'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../WMTable/styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
	var right = _ref.right,
	    first = _ref.first;
	return Object.assign({}, _styles2.default.cell, {
		textAlign: right ? 'right' : 'left',
		paddingLeft: first ? '24px' : 0
	});
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTableCell/styles/index.js